import ModalUI from 'react-modal'
import { CSSProperties, Dispatch, FC, SetStateAction } from 'react'
import { X } from 'lucide-react'
import { Inline } from '@shared/layout/Inline'
import { YellowFilledButton } from '@shared/styles/YellowFilledButton'
import { COLORS } from '@assets/styles/colors'

interface ModalProps {
	setShowModal: Dispatch<SetStateAction<boolean>>
	title: string
	description: string
	buttonsAmount?: 0 | 1 | 2
	firstButtonText?: string
	secondButtonText?: string
	overlayStyle?: CSSProperties
	titleStyle?: CSSProperties
	descriptionStyle?: CSSProperties
	contentStyle?: CSSProperties
	firstButtonStyles?: CSSProperties
	secondButtonStyles?: CSSProperties
	onFirstButtonClick?: () => void
	onSecondButtonClick?: () => void
	onClose?: () => void
}

export const InfoModal: FC<ModalProps> = ({
	setShowModal,
	title,
	description,
	buttonsAmount = 1,
	overlayStyle,
	contentStyle,
	titleStyle,
	descriptionStyle,
	secondButtonStyles,
	firstButtonStyles,
	firstButtonText = 'ОК',
	secondButtonText = 'Закрыть',
	onFirstButtonClick,
	onSecondButtonClick,
	onClose,
}) => {
	const closeModal = () => {
		onClose?.()
		setShowModal(false)
	}

	return (
		<ModalUI
			isOpen={true}
			style={{
				overlay: { backgroundColor: 'rgba(0, 0, 0, 0.2)', ...overlayStyle },
				content: {
					width: 271,
					height: 164,
					background: 'white',
					display: 'flex',
					flexDirection: 'column',
					position: 'absolute',
					top: '50%',
					left: '50%',
					right: 'auto',
					bottom: 'auto',
					transform: 'translate(-50%, -50%)',
					margin: 0,
					padding: 12,
					borderRadius: 14,
					border: 'none',
					boxShadow: '0 24px 70px rgba(0, 0, 0, 0.16)',
					...contentStyle,
				},
			}}>
			<Inline
				style={{ flexDirection: 'row-reverse', overflowX: 'visible' }}
				align={'flex-start'}>
				<button
					type='button'
					aria-label='Закрыть окно'
					onClick={closeModal}
					style={{
						position: 'absolute',
						top: 8,
						right: 8,
						width: 44,
						height: 44,
						display: 'inline-flex',
						alignItems: 'center',
						justifyContent: 'center',
						border: 'none',
						background: 'transparent',
						padding: 0,
						color: '#8B8B95',
					}}>
					<X size={22} strokeWidth={2.2} />
				</button>
				<div
					style={{
						textAlign: 'center',
						fontSize: 17,
						fontWeight: 400,
						width: '100%',
						...titleStyle,
					}}>
					{title}
				</div>
			</Inline>
			<div
				style={{
					fontSize: 11,
					marginTop: 9,
					textAlign: 'center',
					fontWeight: 300,
					...descriptionStyle,
				}}>
				{description}
			</div>

			<div
				style={{
					flexGrow: 1,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'flex-end',
				}}>
				{buttonsAmount === 1 && (
					<YellowFilledButton
						width={197}
						height={38}
						style={{ fontSize: 14, ...firstButtonStyles }}
						onClick={() => {
							if (onFirstButtonClick) onFirstButtonClick()
							closeModal()
						}}>
						{firstButtonText}
					</YellowFilledButton>
				)}
				{buttonsAmount === 2 && (
					<Inline gap={8}>
						<YellowFilledButton
							onClick={() => {
								if (onFirstButtonClick) onFirstButtonClick()
								closeModal()
							}}
							style={{
								background: COLORS.LIGHT_GREY,
								fontSize: 17,
								...firstButtonStyles,
							}}
							height={38}
							width={112}>
							{firstButtonText}
						</YellowFilledButton>
						<YellowFilledButton
							height={38}
							width={112}
							style={{ fontSize: 17, ...secondButtonStyles }}
							onClick={() => {
								if (onSecondButtonClick) onSecondButtonClick()
								closeModal()
							}}>
							{secondButtonText}
						</YellowFilledButton>
					</Inline>
				)}
			</div>
		</ModalUI>
	)
}
